// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as UtilityHooks$OrcaPaymentPage from "../Hooks/UtilityHooks.bs.js";
import * as PaymentShimmer$OrcaPaymentPage from "./PaymentShimmer.bs.js";

function LoaderPaymentShimmer(props) {
  var selectedOption = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.selectedOptionAtom);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  UtilityHooks$OrcaPaymentPage.useHandlePostMessages(false, false, selectedOption, undefined);
  return React.createElement(RenderIf$OrcaPaymentPage.make, {
              condition: match.redirectionInfo === "ShowRedirectionInfo",
              children: React.createElement(PaymentShimmer$OrcaPaymentPage.make, {})
            });
}

var make = LoaderPaymentShimmer;

export {
  make ,
}
/* react Not a pure module */
